module.exports = __webpack_public_path__ + "static/media/male.729d22bd.png";